export default "__VITE_ASSET__S33BJGvI__"